import { IS_MOBILE_BUILD } from "./buildProfile";
import { isNativeApp } from "../native/runtime";

/**
 * Treat the native bridge as the runtime source of truth.
 *
 * The build profile still removes mobile-only code and assets at build time,
 * but a Capacitor shell must never behave like the public website if a web
 * bundle is synced accidentally.
 */
export const isMobileAppRuntime = () => IS_MOBILE_BUILD || isNativeApp();

/**
 * Developer, sandbox and staff-ops surfaces are intentionally web-only.
 * Keep the runtime bridge check even though mobile builds also disable these
 * surfaces at build time, so a mistakenly synced web bundle remains safe.
 */
export const isInternalToolingAvailable = () => !isMobileAppRuntime();
